import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useIdentitySelector = () => useSelector((state: TAppState) => state.identityReducer);
